import { Component, computed, inject } from '@angular/core';

import { ChdButtonPresenter, ChdButtonVariant } from '@cp-produkte/cruise-hospitality-design';

import { ComponentsModule } from '../components.module';

/** App-local dx renderer that draws `ChdIconButton` with the legacy `spa-button`. */
@Component({
  selector: 'spa-chd-icon-button-renderer',
  imports: [ComponentsModule],
  templateUrl: './chd-icon-button-spa-renderer.component.html',
})
export class ChdIconButtonSpaRenderer {
  protected readonly presenter = inject(ChdButtonPresenter);

  protected readonly asset = computed(() => {
    const iconSrc = this.presenter.viewState().iconSrc;
    return /(?:^|\/)([^/?#]+)\.svg(?:[?#].*)?$/.exec(iconSrc)?.[1] ?? '';
  });

  protected shapeFor(variant: ChdButtonVariant): 'primary' | 'secondary' | 'link' {
    if (variant === 'text') {
      return 'link';
    }
    return variant;
  }
}
